import "babel-polyfill";
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import { HashRouter } from 'react-router-dom';
import { configure } from "mobx";
import {mobilecheck} from "./utils/Utils";

import ComapFrontend from './ComapFrontend';
import AppStore from './stores/AppStore'

import registerServiceWorker from './registerServiceWorker';

import './index.css';

configure({enforceActions:true});

const appConfig = window.appConfig;//CODE-REVIEW:KG I think this is backwards. The specific implementation in dev should reference the CoMap components so that this hack isn't needed in the library
let appStore = new AppStore();
appStore.loadConfig(appConfig);

if (mobilecheck()){
    appStore.setIsMobile(true);
    appStore.setDrawer({open:false, active:''});
}

if (appStore.environment === 'staging'){
    console.log('appConfig: ', appConfig);
    console.log('appStore: ', appStore);
} else if (appStore.environment === 'production') {

}

ReactDOM.render((
    <HashRouter>
        <Provider appStore={appStore}>
            <ComapFrontend appStore={appStore}/>
        </Provider>
    </HashRouter>),
        document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js